// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3216": "04a82482","326": "cd75efc3","4282": "fbcaeda5","4651": "fd1698a8","7753": "6ad99b25","8240": "3a2da18e",}[chunkId] + ".css"
}